export default "__VITE_ASSET__DIHhhIe3__"